<mat-tab-group id="license-view-layout-tabs" [mat-stretch-tabs]="false">
  <mat-tab label="Contract Info">
    <div class="pdt-20">
      <app-contract-summary #contractSummary [contract]="contract"></app-contract-summary>
      <div class="view-contract-grid" [class.with-tokens]="showTokens && contract.product != 'FSBLOCKER'">
        <div class="view-contract-grid-main" id="licenseDetailsContainer" *ngIf="contract.product != 'CLONEMANAGER' && contract.product != 'PROTECT_FOR_VMS' && contract.product != 'VA'">
          <mat-card>
            <mat-card-content>
              <app-license-details [contractDetails]="contract"></app-license-details>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="view-contract-grid-side" id="tokenDetailsContainer" *ngIf="showTokens && contract.product != 'FSBLOCKER'">
          <mat-card>
            <mat-card-content>
              <app-token-details [tokenDetails]="contract"></app-token-details>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Activations">
    <div class="pdt-20" *ngIf="contract && contract.product != 'CLONEMANAGER' && contract.product != 'PROTECT_FOR_VMS' && contract.product != 'SYSBACK'">
      <mat-tab-group id="view-tab-group" [mat-stretch-tabs]="false" [selectedIndex]="activeTab - 1" (selectedIndexChange)="activeTab = $event + 1">
        <mat-tab label="Active Licenses ({{active.length}})">
          <app-activation-details [loading]="loading" [rental]="contract.rental" [activations]="active" [showSurrender]="false" [showComments]="showComments" [contractId]="contract.id"></app-activation-details>
        </mat-tab>
        <mat-tab *ngIf="contract.rental" label="Expired Licenses ({{expired.length}})">
          <app-activation-details [loading]="loading" [rental]="contract.rental" [activations]="expired" [showSurrender]="false" [showComments]="showComments" [contractId]="contract.id"></app-activation-details>
        </mat-tab>
        <mat-tab label="Surrendered Licenses ({{surrendered.length}})">
          <app-activation-details [loading]="loading" [rental]="contract.rental" [activations]="surrendered" [showSurrender]="false" [showComments]="showComments" [showLicenseDetails]="false" [contractId]="contract.id"></app-activation-details>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-tab>
</mat-tab-group>
